export const attachmentQuestions = [
  {
    "id": 1,
    "scenario": "친구와 큰 다툼이 있었다면, 내 행동은?",
    "responses": [
      { "text": "상대와의 거리를 유지하며 상황이 나아지기를 기다린다", "selfImage": "positive", "othersImage": "negative" },
      { "text": "어떻게 대처해야 할지 몰라 답답함을 느낀다", "selfImage": "negative", "othersImage": "negative" },
      { "text": "상대방과 대화를 통해 문제를 해결하려 한다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "내가 잘못한 건 아닐지 계속 고민한다", "selfImage": "negative", "othersImage": "positive" }
    ]
  },
  {
    "id": 2,
    "scenario": "가까운 친구가 갑자기 연락을 끊는다면, 내 기분은?",
    "responses": [
      { "text": "왜 이런 상황이 생겼는지 생각이 많아진다", "selfImage": "negative", "othersImage": "negative" },
      { "text": "내가 무언가 잘못한 건 아닌지 불안해한다", "selfImage": "negative", "othersImage": "positive" },
      { "text": "상대방의 사정을 이해하며 기다린다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "상대방이 필요하면 연락하겠지 하고 신경 쓰지 않는다", "selfImage": "positive", "othersImage": "negative" }
    ]
  },
  {
    "id": 3,
    "scenario": "누군가 나를 칭찬했을 때, 내 마음은?",
    "responses": [
      { "text": "칭찬에 어떻게 반응해야 할지 몰라 당황한다", "selfImage": "negative", "othersImage": "negative" },
      { "text": "칭찬을 진심으로 받아들이며 감사함을 느낀다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "칭찬이 진심인지 의심하며 마음이 불편해진다", "selfImage": "negative", "othersImage": "positive" },
      { "text": "칭찬을 크게 신경 쓰지 않고 넘어간다", "selfImage": "positive", "othersImage": "negative" }
    ]
  },
  {
    "id": 4,
    "scenario": "가까운 사람이 예상치 못한 도움을 요청했을 때, 내 반응은?",
    "responses": [
      { "text": "도움 요청이 부담스러워 피하고 싶어진다", "selfImage": "negative", "othersImage": "negative" },
      { "text": "즉시 도와주며 상대방이 만족하길 바란다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "내가 잘할 수 있을지 고민하며 망설인다", "selfImage": "negative", "othersImage": "positive" },
      { "text": "도움을 주되 무리하지 않으려 한다", "selfImage": "positive", "othersImage": "negative" }
    ]
  },
  {
    "id": 5,
    "scenario": "친구와 노는 약속이 갑자기 취소된다면, 내 기분은?",
    "responses": [
      { "text": "이해하려고 하지만, 막연하게 불안해진다", "selfImage": "negative", "othersImage": "negative" },
      { "text": "취소된 이유를 묻고 다시 약속을 잡을 방법을 고민한다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "상대방이 날 멀리하는 건 아닌지 걱정한다", "selfImage": "negative", "othersImage": "positive" },
      { "text": "오히려 내 개인적인 시간이 생겨 좋기도 하다", "selfImage": "positive", "othersImage": "negative" }
    ]
  },
  {
    "id": 6,
    "scenario": "상대방이 내 이야기에 무관심한 것처럼 보일 때, 내 행동은?",
    "responses": [
      { "text": "상대방이 왜 그러는지 계속 신경 쓰인다", "selfImage": "negative", "othersImage": "positive" },
      { "text": "어떻게 반응해야 할지 몰라 말을 줄인다", "selfImage": "negative", "othersImage": "negative" },
      { "text": "상대방의 사정을 이해하며 대화를 이어간다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "나도 신경을 끄고 내가 해야할 일을 한다", "selfImage": "positive", "othersImage": "negative" }
    ]
  },
  {
    "id": 7,
    "scenario": "중요한 자리에서 예상치 못한 질문을 받았을 때, 내 반응은?",
    "responses": [
      { "text": "질문에 대해 생각하며 침착하게 답한다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "질문을 받아들였지만 답을 떠올리지 못해 긴장한다", "selfImage": "negative", "othersImage": "negative" },
      { "text": "내 답변이 부족하게 보일까 걱정한다", "selfImage": "negative", "othersImage": "positive" },
      { "text": "최선을 다해 답변하며 결과에 연연하지 않는다", "selfImage": "positive", "othersImage": "negative" }
    ]
  },
  {
    "id": 8,
    "scenario": "일상에서 사소한 실수를 했을 때, 내 반응은?",
    "responses": [
      { "text": "실수로 인해 다른 사람이 나를 어떻게 생각할지 고민한다", "selfImage": "negative", "othersImage": "positive" },
      { "text": "실수를 바로잡으며 크게 신경 쓰지 않는다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "실수를 반복하지 않기 위해 조심한다", "selfImage": "positive", "othersImage": "negative" },
      { "text": "실수로 인해 불편한 마음이 쉽게 가라앉지 않는다", "selfImage": "negative", "othersImage": "negative" }
    ]
  },
  {
    "id": 9,
    "scenario": "처음 만난 사람과 대화를 시작할 때, 내 마음은?",
    "responses": [
      { "text": "상대방이 내 얘기를 좋아할지 걱정한다", "selfImage": "negative", "othersImage": "positive" },
      { "text": "자연스럽게 대화를 이어가며 분위기를 만든다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "어색한 침묵을 피하기 위해 주제를 생각한다", "selfImage": "positive", "othersImage": "negative" },
      { "text": "내가 너무 소극적으로 보일까 고민한다", "selfImage": "negative", "othersImage": "negative" }
    ]
  },
  {
    "id": 10,
    "scenario": "가깝던 사람과 관계가 점점 소원해지는 것을 느낄 때, 내 행동은?",
    "responses": [
      { "text": "관계를 회복하기 위해 대화를 시도한다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "상대방이 거리를 두는 이유를 고민하며 불안해한다", "selfImage": "negative", "othersImage": "positive" },
      { "text": "상대방의 결정을 존중하며 자연스럽게 거리를 둔다", "selfImage": "positive", "othersImage": "negative" },
      { "text": "관계를 이어가야 할지 말아야 할지 판단하지 못한다", "selfImage": "negative", "othersImage": "negative" }
    ]
  },
  {
    "id": 11,
    "scenario": "내 실수로 인해 예상치 못한 문제가 발생했다면?",
    "responses": [
      { "text": "문제를 해결하기 위해 필요한 조치를 취한다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "내 실수가 다른 사람에게 미친 영향이 계속 걱정된다", "selfImage": "negative", "othersImage": "positive" },
      { "text": "실수를 인정하고 최대한 조용히 넘어간다", "selfImage": "positive", "othersImage": "negative" },
      { "text": "어떻게 해야 할지 몰라 우왕좌왕한다", "selfImage": "negative", "othersImage": "negative" }
    ]
  },
  {
    "id": 12,
    "scenario": "가까운 사람과 대화 중 기분이 계속 안 좋아 보인다면?",
    "responses": [
      { "text": "상대방의 상태를 이해하며 기분을 풀어준다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "내가 상대에게 실수한 건 아닐까 걱정한다", "selfImage": "negative", "othersImage": "positive" },
      { "text": "굳이 말을 걸지 않고 다른 일을 한다", "selfImage": "positive", "othersImage": "negative" },
      { "text": "어떻게 반응해야 할지 모르고 나도 화가 난다", "selfImage": "negative", "othersImage": "negative" }
    ]
  },
  {
    "id": 13,
    "scenario": "중요한 회의에서 내 의견이 받아들여지지 않는다면?",
    "responses": [
      { "text": "내 의견을 명확히 설명하며 타협점을 찾으려 한다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "내 의견이 틀렸을까 봐 걱정하며 조용해진다", "selfImage": "negative", "othersImage": "positive" },
      { "text": "더 이상 의견을 주장하지 않고 물러난다", "selfImage": "positive", "othersImage": "negative" },
      { "text": "어떻게 대응해야 할지 몰라 혼란스럽다", "selfImage": "negative", "othersImage": "negative" }
    ]
  },
  {
    "id": 14,
    "scenario": "새로운 환경에서 적응해야 할 때, 내 행동은?",
    "responses": [
      { "text": "적응이 쉽지 않아 긴장감을 느낀다", "selfImage": "negative", "othersImage": "negative" },
      { "text": "새로운 환경의 규칙과 사람들을 파악하며 조화를 찾는다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "적응이 쉽지 않을 것 같아 혼자만의 시간을 가지려 한다", "selfImage": "negative", "othersImage": "positive" },
      { "text": "주변 사람들과 적극적으로 소통하며 적응한다", "selfImage": "positive", "othersImage": "negative" }
    ]
  },
  {
    "id": 15,
    "scenario": "가까운 사람이 나에게 중요한 부탁을 한다면?",
    "responses": [
      { "text": "상대방을 위해 진심으로 도와준다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "기대를 충족하지 못할까 봐 불안해한다", "selfImage": "negative", "othersImage": "positive" },
      { "text": "기대가 부담스러워 거리를 두려 한다", "selfImage": "negative", "othersImage": "negative" },
      { "text": "내가 손해보지 않는 선에서 열심히 해준다", "selfImage": "positive", "othersImage": "negative" }
    ]
  },
  {
    "id": 16,
    "scenario": "상대방이 내게 충고를 했을 때, 내 마음은?",
    "responses": [
      { "text": "충고를 긍정적으로 받아들이고 돌아본다", "selfImage": "positive", "othersImage": "positive" },
      { "text": "나에 대한 막연한 비판으로 받아들여질 때가 많다", "selfImage": "negative", "othersImage": "negative" },
      { "text": "크게 수용하지 않지만 보여지는 부분은 개선한다", "selfImage": "positive", "othersImage": "negative" },
      { "text": "내가 얼마나 많은 실수를 했을지 생각하며 힘이 빠진다", "selfImage": "negative", "othersImage": "positive" }
    ]
  }
  // {
  //   "id": 17,
  //   "scenario": "팀원들과 의견 충돌이 발생했을 때, 내 행동은?",
  //   "responses": [
  //     { "text": "충돌을 조율하기 위해 중립적인 태도를 유지한다", "selfImage": "positive", "othersImage": "positive" },
  //     { "text": "내 의견을 끝까지 주장하며 설득하려 한다", "selfImage": "positive", "othersImage": "negative" },
  //     { "text": "상대의 반응이 불편해져 의견을 포기하려 한다", "selfImage": "negative", "othersImage": "negative" },
  //     { "text": "상대방의 의견을 깊이 고민하며 내 입장을 조정한다", "selfImage": "negative", "othersImage": "positive" }
  //   ]
  // },
  // {
  //   "id": 18,
  //   "scenario": "상대방이 내 부탁을 정중히 거절했다면, 내 반응은?",
  //   "responses": [
  //     { "text": "상대방의 사정을 이해하며 크게 신경 쓰지 않는다", "selfImage": "positive", "othersImage": "negative" },
  //     { "text": "내 부탁이 무리였는지 돌아보며 고민한다", "selfImage": "negative", "othersImage": "positive" },
  //     { "text": "거절이 마음에 남아 불편한 감정을 느낀다", "selfImage": "negative", "othersImage": "negative" },
  //     { "text": "상황을 자연스럽게 받아들이며 다른 방법을 찾는다", "selfImage": "positive", "othersImage": "positive" }
  //   ]
  // },
  // {
  //   "id": 19,
  //   "scenario": "약속 장소에 늦게 도착했을 때, 상대방의 반응을 생각하면 내 기분은?",
  //   "responses": [
  //     { "text": "상대방이 화가 났을까 봐 불안해진다", "selfImage": "negative", "othersImage": "positive" },
  //     { "text": "미안한 마음이 크지만 상대방을 믿고 차분히 설명한다", "selfImage": "positive", "othersImage": "positive" },
  //     { "text": "늦은 이유를 과도하게 신경 쓰며 스트레스를 받는다", "selfImage": "negative", "othersImage": "negative" },
  //     { "text": "늦은 상황을 담담하게 받아들이며 상대방에게 사과한다", "selfImage": "positive", "othersImage": "negative" }
  //   ]
  // },
  // {
  //   "id": 20,
  //   "scenario": "예정된 계획이 틀어졌을 때, 내 반응은?",
  //   "responses": [
  //     { "text": "상황에 적응하며 새로운 계획을 세운다", "selfImage": "positive", "othersImage": "positive" },
  //     { "text": "계획이 틀어진 이유를 돌아보며 불안해한다", "selfImage": "negative", "othersImage": "positive" },
  //     { "text": "계획이 틀어진 상황에 크게 스트레스를 받는다", "selfImage": "negative", "othersImage": "negative" },
  //     { "text": "틀어진 상황을 침착하게 받아들이며 시간을 보낸다", "selfImage": "positive", "othersImage": "negative" }
  //   ]
  // },

]; 